import { useEffect, useMemo, useState } from "react";
import { toast } from "react-toastify";
import { makeStyles } from "@mui/styles";
import { Grid, ToggleButton, ToggleButtonGroup } from "@mui/material";

import {
  getContactUsData,
  putContactUs,
} from "../../../services/ContactUsService";

import ContactUsTable from "../../../components/CustomTable/ContactUsTable";

const useStyles = makeStyles({
  root: {},
});

const toggleButtons = [
  { title: "New", value: "new", color: "warning" },
  { title: "Open", value: "open", color: "primary" },
  { title: "Fixed", value: "fixed", color: "success" },
  { title: "Closed", value: "closed", color: "error" },
];

export default function ContactUs() {
  const classes = useStyles();
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedStatusFilter, setSelectedStatusFilter] = useState("open");

  const filteredData = useMemo(() => {
    return data.filter(
      (item) =>
        selectedStatusFilter === "" || item.STATUS === selectedStatusFilter
    );
  }, [data, selectedStatusFilter]);

  const retrieveContactUsData = async () => {
    try {
      setIsLoading(true);
      const resContactUsData = await getContactUsData();
      setData(resContactUsData);
      setIsLoading(false);
    } catch (e) {
      console.error(e);
      toast.error("Unexpected error occurs!");
    }
  };

  useEffect(() => {
    retrieveContactUsData();
  }, []);

  const handleStatusFilterChange = (e) => {
    setSelectedStatusFilter(e.target.value);
  };

  const handleRowEdit = (rowData) => {
    const putData = {
      ...rowData,
      RESOLUTION: rowData.RESOLUTION,
      COMMENTS: rowData.COMMENTS,
      STATUS: rowData.STATUS,
      SEVERITY: rowData.SEVERITY,
    };

    setIsLoading(true);

    putContactUs(putData)
      .then(async (res) => {
        setIsLoading(false);
        if (res.status === 200) {
          await retrieveContactUsData();
          toast.success("Entry updated.");
        } else toast.error("Entry not updated!");
      })
      .catch((e) => {
        setIsLoading(false);
        console.error(e);
        toast.error("Unexpected error occurs while updating the data!");
      });
  };

  return (
    <div className={classes.root}>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Grid container justifyContent="flex-end">
            <Grid item>
              <ToggleButtonGroup
                size="small"
                aria-label="Status"
                value={selectedStatusFilter}
                onChange={handleStatusFilterChange}
                exclusive
              >
                <ToggleButton value="">All</ToggleButton>
                {toggleButtons.map((button) => (
                  <ToggleButton
                    key={button.value}
                    color={button.color}
                    value={button.value}
                  >
                    {button.title}
                  </ToggleButton>
                ))}
              </ToggleButtonGroup>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <ContactUsTable
            title="Contact Us"
            loading={isLoading}
            items={filteredData}
            hiddenColumns={["DESCRIPTION", "RESOLUTION", "COMMENTS"]}
            handleEdit={handleRowEdit}
          />
        </Grid>
      </Grid>
    </div>
  );
}
